"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CancellationPolicy;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("@chakra-ui/react");
var _atoms = require("@whitbread-eos/atoms");
var _utils = require("@whitbread-eos/utils");
var _nextI18next = require("next-i18next");
var _BookingSummaryUpgradeToFlex = _interopRequireDefault(require("../../common/BookingSummary/BookingSummaryUpgradeToFlex/BookingSummaryUpgradeToFlex"));
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function CancellationPolicy(_ref) {
  var {
    rateDescription,
    updateToFlex,
    rate
  } = _ref;
  var {
    t
  } = (0, _nextI18next.useTranslation)(['common']);
  var rateText = t('booking.cancellation.policy.description').replace('{rate}', "<strong>".concat(rate, "</strong>"));
  return (0, _jsxRuntime.jsxs)(_react.Flex, _objectSpread(_objectSpread({
    "data-testid": "cancellationPolicy"
  }, cancelBoxStyle), {}, {
    children: [(0, _jsxRuntime.jsx)(_atoms.CancelPolicy, {
      style: {
        display: 'inline'
      }
    }), (0, _jsxRuntime.jsx)(_react.Text, _objectSpread(_objectSpread({
      as: "h5"
    }, cancelHeaderStyle), {}, {
      children: t('booking.cancellation.policy.title')
    })), (0, _jsxRuntime.jsxs)(_react.Text, _objectSpread(_objectSpread({}, cancelTextStyle), {}, {
      children: [(0, _utils.renderSanitizedHtml)(rateText), " ", rateDescription]
    })), (updateToFlex === null || updateToFlex === void 0 ? void 0 : updateToFlex.showUpgradeToFlex) && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [(0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({}, dividerStyle), {}, {
        children: (0, _jsxRuntime.jsx)("hr", {})
      })), (0, _jsxRuntime.jsx)(_BookingSummaryUpgradeToFlex.default, _objectSpread(_objectSpread({}, updateToFlex), {}, {
        t: t
      }))]
    })]
  }));
}
var cancelBoxStyle = {
  display: {
    lg: 'none',
    mobile: 'flex'
  },
  backgroundColor: 'lightGrey5',
  border: '1px solid var(--chakra-colors-lightGrey2)',
  borderRadius: 'md',
  mt: 'lg',
  padding: 'md',
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'center'
};
var cancelHeaderStyle = {
  color: 'var(--chakra-colors-tertiary)',
  fontWeight: 'var(--chakra-fontWeights-bold)',
  display: 'inline-flex',
  ml: 'sm'
};
var cancelTextStyle = {
  mt: 'md',
  mb: 'md'
};
var dividerStyle = {
  width: '100%',
  mb: 'md'
};